module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-start py-2 px-4"
  }, [_c('h3', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Restablecer Contraseña")]), _vm._v(" "), _c('p', [_vm._v("Cambia tu contraseña")]), _vm._v(" "), _c('div', {
    staticClass: "form-group w-100"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": "getPass"
    }
  }, [_vm._v("Nueva Contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newpassword),
      expression: "newpassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "getPass",
      "aria-describedby": "getPass",
      "placeholder": "*************"
    },
    domProps: {
      "value": (_vm.newpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newpassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group w-100"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": "getPass2"
    }
  }, [_vm._v("Repetir Nueva Contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifypassword),
      expression: "verifypassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "getPass2",
      "aria-describedby": "getPass2",
      "placeholder": "*************"
    },
    domProps: {
      "value": (_vm.verifypassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifypassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary mt-4 btn-lg btn-block",
    attrs: {
      "to": "/confirmpass"
    }
  }, [_vm._v("Continuar")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-915f8d4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RestorePassword.vue
// module id = 1903
// module chunks = 1